import { render } from "./NotificationComponent.vue?vue&type=template&id=10ceed1f"
import script from "./NotificationComponent.vue?vue&type=script&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Notification/NotificationComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10ceed1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10ceed1f', __exports__)) {
    api.reload('10ceed1f', __exports__)
  }
  
  module.hot.accept("./NotificationComponent.vue?vue&type=template&id=10ceed1f", () => {
    api.rerender('10ceed1f', render)
  })

}


export default __exports__